import React, { useState } from "react";

export interface Option {
  value: string;
  label: React.ReactNode;
}

export interface SelectProps {
  onChange: (value: string) => void;
  options: Option[];
  selected?: Option;
  value?: string; // <- bu qo‘shilsa xatolik ketadi
}

export const Select: React.FC<SelectProps> = ({
  onChange,
  options,
  selected,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-[120px] text-gray-700 text-xs">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between gap-4 bg-white border border-gray-200 hover:border-gray-300 transition-colors px-2.5 py-1.5 rounded-full w-full focus:outline-none shadow-sm"
      >
        <span className="flex items-center gap-1">
          {selected?.label ?? "Select"}
        </span>
        <svg
          className={`w-4 h-4 text-gray-500 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute mt-1 w-full bg-white border border-gray-100 rounded-xl shadow-md z-10 overflow-hidden">
          {options.map((opt) => (
            <button
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className="flex items-center gap-2 w-full px-2.5 py-1.5 text-left hover:bg-gray-50 transition-colors"
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
